// Register service worker for PWA support
export function registerServiceWorker() {
  // Only register in production environment to avoid development issues
  const isProduction = window.location.hostname !== 'localhost' && 
                      !window.location.hostname.includes('127.0.0.1');
  
  if ('serviceWorker' in navigator && isProduction) {
    window.addEventListener('load', () => {
      // Delay registration slightly to prioritize app initialization
      setTimeout(() => {
        navigator.serviceWorker.register('/service-worker.js')
          .then(registration => {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
          })
          .catch(error => {
            console.error('ServiceWorker registration failed: ', error);
          });
      }, 1000);
    });
  } else {
    // In development, unregister any existing service workers to prevent caching issues
    if ('serviceWorker' in navigator && !isProduction) {
      unregisterServiceWorker();
    }
  }
}

// Unregister service worker (useful for development)
export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister();
        console.log('ServiceWorker unregistered');
      }
    });
  }
} 